// eslint-disable-next-line
import util from 'util';

import { createTheme,createStyles } from '@material-ui/core/styles';

/*
 * Create the theme object
 */

/* Usage: BACKGROUNDS, HEADLINE TEXT, ICONS */
let poshWhite = "#f3f1ed";
/* BACKGROUNDS, BODY COPY TEXT */
let poshBlack = "#101820";
/* BACKGROUNDS, HEADLINE TEXT (on white), SUBHEAD TEXT */
let poshBlue = 'rgba(0,0,0,0.1)';
/* BACKGROUNDS, HEADLINE TEXT (on white), SUBHEAD TEXT, ICONS */
// let poshLightGreen = "#A0E395";
/* ACCENTS, BUTTONS, HEADLINE TEXT (on white), SUBHEAD TEXT, ICONS */
let poshMediumGreen = "#6FC097";
/* ACCENTS, BUTTONS, SUBHEAD TEXT, ICONS */
// let poshDarkGreen = "#2C886B";

let rubyDarkPurple = '#7F2062';
let rubyMediumPurple = '#9F5789';

let rubyIconColor = "#EF9CA1";

// Used in sidedrawer
let rubyLightPurple = '#AB6D98'

export default function theme() {
  return(createTheme({
    
    brandingColors: {
      poshWhite,
      poshBlack,
      poshBlue,
      rubyDarkBlue: "#102259",
      poshMediumGreen,
      rubyRed:"#e5136c",
      rubyDarkPurple,
      rubyLightPurple,
      rubyBlue: "rgb(50,150,157)",
      loginGradient : 'linear-gradient(160deg, #f4cac9, #ee9ca1)',
    },
    sizes: {
      appBar: '64px',
      drawerWidth: '90px',
      agentSessionAppBar: '104px'
    },
    palette: {
      primary: {
        main : poshBlue,
      },
      secondary: {
        main : '#F8D68B',
      },
      icon: {
        main: rubyIconColor
      }
    },
    typography : {
      useNextVariants: true,
    },
    props : {
      MuiButton : {
        variant: 'contained',
      },
      MuiTextField : {
        variant: 'outlined',
      },
      MuiInputLabel : {
        shrink: true,
      },
      MuiOutlinedInput : {
        notched: true,
      },
    },
    overrides : {
      MuiButton : {
        contained : {
          color: poshWhite,
          textTransform: 'none',
          fontFamily: 'Sofia',
          fontWeight: 700,
          backgroundColor: rubyDarkPurple,
          '&.Mui-disabled' : {
            backgroundImage: 'none',
            backgroundColor: 'rgba(0,0,0,0.1)',
            color: 'rgba(0,0,0,0.4)',
          },
          '&:hover' : {
            backgroundImage: 'none',
            backgroundColor: rubyMediumPurple,
          },
          
          borderRadius: 100,
        },
        containedPrimary: {
          color: poshWhite,
          textTransform: 'none',
          fontFamily: 'Sofia',
          fontWeight: 700,
          backgroundColor: rubyDarkPurple,
          '&.Mui-disabled' : {
            backgroundImage: 'none',
            backgroundColor: 'rgba(0,0,0,0.1)',
            color: 'rgba(0,0,0,0.4)',
          },
          '&:hover' : {
            backgroundImage: 'none',
            backgroundColor: rubyMediumPurple,
          },
          
          borderRadius: 100,
        },
        text : {
          color: poshWhite,
          textDecoration: 'underline dotted',
        },
      },
      MuiMenuItem: createStyles({
        root: {
          "&&:hover": {
            // backgroundColor: "gray",
            // color: "white"
          },
        },
        selected: {
          // "&&": {
          //   backgroundColor: "#000",
          //   color: "white",
          //   "&& span": {
          //     color: "white"
          //   }
          // },
          // "&&:hover": {
          //   backgroundColor: "darkblue",
          //   color: "white"
          // }
        }
      }),

      MuiIconButton : {
      },
      
      MuiDialog : {
        paper : {
          // color: poshWhite,
          backgroundColor: '#FCF9F2',
          borderRadius: 10,
        },
      },
      MuiDialogActions : {
        root : {
          justifyContent: 'center',
          paddingTop: 25,
          paddingBottom: 25,
        },
      },
      MuiDialogContentText : {
        root : {
          // color: poshWhite,
          fontFamily: 'Sofia'
        }
      },
      MuiDialogTitle : {
        root: {
          fontFamily: 'Sofia-bold'
        }
      },
      MuiAppBar : {
        root: {
          backgroundColor: poshBlue,
        }
      },
      /* Dark gradient menu option
      MuiList : {
        root : {
         color: poshWhite,
         backgroundColor: poshBlue,
        },
      },
      MuiListItemIcon : {
        root : {
          color: poshMediumGreen,
        },
      },
      */
      /* Light outlined menu */
      MuiList : {
        root : {
          // borderColor: poshMediumGreen,
          // borderWidth: 2,
          // borderStyle: 'solid',
          // borderRadius: 10,
        },
      },
      MuiTypography: {
        root : {
          fontFamily: 'Sofia'
        }
      },
      MuiPopover : {
        paper : {
          borderRadius: 10,
          '& .Mui-selected' : {
            // color: poshBlue,
            // backgroundColor: poshWhite,
          },
        },
      },
      MuiListItemIcon : {
        root : {
          color: rubyIconColor,
        },
      },
      MuiTableCell : {
        root : {
          borderBottom: 'none',
        },
      },
      MuiOutlinedInput : {
        root : {
          '& fieldset': {
            // borderRadius: 100,
            fontFamily: 'Sofia'
          },
          '& .MuiOutlinedInput-input': {
            paddingTop: 8,
            paddingBottom: 8,
          },
          '& .MuiOutlinedInput-inputSelect': {
            '&:focus' : {
              // borderRadius: 100,
              fontFamily: 'Sofia'
            }
          },
        },
        multiline : {
          padding: 8,
          '& fieldset': {
            borderRadius: 20,
          },
        }
      },
      /* Date and time picker */
      MuiPickersModal : {
        dialogRoot : {
          backgroundImage: 'none',
          backgroundColor: poshWhite,
        },
        '& .MuiDialogActions-root': {
          '& button': {
            backgroundColor: '#000'
          }
        }
      },
      MuiPickersDay : {
        daySelected: {
          backgroundColor: "rgba(0,0,0,0.4)"
        }
      },
      MuiPickersClock: {
        pin: {
          backgroundColor: "rgba(0,0,0,0.4)"
        }
      },
      MuiPickersClockPointer: {
        pointer: {
          backgroundColor: "rgba(0,0,0,0.4)"
        },
        thumb: {
          backgroundColor: "rgba(0,0,0,0.4)"
        }
      },
      MuiPickersClockNumber: {
        clockNumberSelected: {
          backgroundColor: "rgba(0,0,0,0.4)"
        }
      },
      MuiPickerDTTabs: {
        tabs: {
          color: '#000'
        }
      },
      MuiPickersToolbarText: {
        toolbarBtnSelected: {
          color: '#000'
        },
        toolbarTxt: {
          color: 'rgba(0, 0, 0, 0.54)'
        }
      },
      MuiPickersToolbar : {
        backgroundImage: poshWhite,
        toolbar: {
          '& button': {
            textDecoration: 'none currentcolor solid',
          },
          // '& span': {
          //   '& .MuiPickersToolbarText-toolbarBtnSelected': {
          //     color: '#000'
          //   },
            // '& .MuiPickersToolbarText-toolbarTxt': {
            //   color: 'rgba(0, 0, 0, 0.54)'
            // }

          // }
        }
      
      },
      MuiFormLabel: {
          root: {
            '&$focused': {
              color:'rgba(0, 0, 0, 0.54)'
            }
          }
      }

    },

    
  }));
}
